let collectionTitle = document.querySelector('.collection-custom-sortby__title');
let collectionList = document.querySelector('.collection-custom-sortby');
let customOption = document.querySelectorAll('.custom-sort-option');
let collectionSortTitle = document.querySelector('.collection-sort-by-title');
if (document.querySelector('.cl_sort_by_value_wrapper')) {
    let sortValue = document.querySelector('.cl_sort_by_value_wrapper')
}
if (collectionTitle) {
    collectionTitle.addEventListener('click', () => {
        collectionList.classList.toggle('is-active');
    });
    customOption.forEach((option) => {
        option.addEventListener('click', () => {
            let select = document.querySelectorAll('#SortBySt option');
            let optionData = option.dataset.value;
            let optionText = option.dataset.info;
            if (document.querySelector('.cl_sort_by_value_wrapper')) {
                sortValue.innerHTML = option.dataset.info;
            }
            console.log(optionText)
            collectionList.classList.remove('is-active');

            select.forEach((el) => {
                if (el.value === optionData) {
                    collectionSortTitle.innerHTML = option.innerHTML;
                    el.setAttribute('selected', 'selected');
                    $("#SortBy").val(optionData).trigger('change');
                } else {
                    el.removeAttribute('selected')
                }

            })
        });
    });
}

let filterBx = document.querySelector('.filterBx__categories');
if (filterBx) {
    let buttonCategories = filterBx.querySelector('button');
    if (buttonCategories) {
        buttonCategories.addEventListener('click', () => {
            filterBx.classList.toggle('is-active');
        });
    }
}

let dyFilters = document.querySelectorAll('.dyFilters');
let flby = document.querySelector('.flby');

if (dyFilters.length === 0) {
    if (flby) {
        flby.classList.add('none');
    }
}

//bakcDropFilter
let backdropFilter = document.querySelector('.backdropFilter');
if (backdropFilter) {
    let sb_filter = document.querySelector('.sb_filter');
    backdropFilter.addEventListener('click', () => {
        sb_filter.classList.toggle('active');
        $("html").removeClass("no-scroll");
    });
}

//LoadMorePosts

let loadMorePosts = document.querySelector('.load-more-posts');
if (loadMorePosts) {

    function loadMoreClick() {
        let loadingBox = document.querySelector('.loadingBox');
        loadingBox.classList.add('is-active');

        let postsOnPage = document.querySelector('.grid--blog');

        let loadNextPage = document.querySelector('.next-page__load');
        let loadNextPageValue = loadNextPage.querySelector('.url_page').value;
        let loadTotalPage = loadNextPage.querySelector('.total__page').value;


        fetch(loadNextPageValue)
            .then((response) => {
                return response.text();
            })
            .then((data) => {
                let newDiv = document.createElement('div');
                newDiv.innerHTML = data;
                let newPosts = newDiv.querySelectorAll('.grid--blog .grid__item');

                newPosts.forEach((div) => {
                    postsOnPage.append(div);
                });

                let newLoadNextPage = newDiv.querySelector('.next-page__load');
                let newLoadNextPageValue = newLoadNextPage.querySelector('.url_page').value;
                let newLoadCurrentPage = newLoadNextPage.querySelector('.current__page').value;

                loadNextPage.querySelector('.url_page').value = newLoadNextPageValue;

                if (newLoadCurrentPage === loadTotalPage) {
                    loadMorePosts.remove();
                }
                loadingBox.classList.remove('is-active');
            });
    }
}

if (document.querySelector('.cmi_filter_button') && window.innerWidth > 1023) {
    let showButton = document.querySelector('.cmi_filter_button');
    let filterWrapper = document.querySelector('.cmi_filters ')
    showButton.addEventListener('click',function(){
        document.querySelector('.icon-filter').classList.toggle('hide');
        document.querySelector('.icon-cross').classList.toggle('hide');
        if (filterWrapper.classList.contains('acvtive')) {
            filterWrapper.classList.remove('acvtive');
            filterWrapper.style.maxHeight = 0 + 'px';
        } else {
            filterWrapper.classList.add('acvtive');
            filterWrapper.style.maxHeight = filterWrapper.scrollHeight + 'px';
        }
    })
}

if (document.querySelector('.grid_banner')) {
    document.querySelectorAll('.grid_banner').forEach( banner => {
        let bannerHeight = banner.previousElementSibling.firstElementChild.offsetHeight;
        banner.style.height = bannerHeight - 6.5 + 'px';
    } )
}





//fix collection grid on load:
if ($('#collectionPr').length && $("a.loadMore").length) {

    

    if ($('.grid_banner#first_banner').length > 1) {
        $('.grid_banner#first_banner').last().remove();
    }
    if ($('.grid_banner#second_banner').length > 1) {
        $('.grid_banner#second_banner').last().remove();
    }
    if ($('.grid_banner#third_banner').length > 1) {
        $('.grid_banner#third_banner').last().remove();
    }

    let totalProductsLoaded = $('#collectionPr > .grid__item').length
    let productsPerRowDesktop = Number( $('#collectionPr').attr("data-product-per-row-desktop"))
    let productsPerRowMobile = 2
    let needToHideProductsDesktopCount = -1 * (totalProductsLoaded % productsPerRowDesktop)
    let needToHideProductsMobileCount = -1 * (totalProductsLoaded % productsPerRowMobile)

    if ( needToHideProductsDesktopCount < 0) {
        $('#collectionPr > .grid__item').slice(needToHideProductsDesktopCount).addClass("hide-desktop");
    }
    if ( needToHideProductsMobileCount < 0) {
        $('#collectionPr > .grid__item').slice(needToHideProductsMobileCount).addClass("hide-mobile");
    }
}
